export const GET_FREELANCERS_SUCCESS = 'GET_FREELANCERS_SUCCESS';
export const GET_FREELANCERS_FAILED = 'GET_FREELANCERS_FAILED';
